import { render, staticRenderFns } from "./HealthInformation.vue?vue&type=template&id=413224b8&scoped=true"
import script from "./HealthInformation.vue?vue&type=script&lang=ts"
export * from "./HealthInformation.vue?vue&type=script&lang=ts"
import style0 from "./HealthInformation.vue?vue&type=style&index=0&id=413224b8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413224b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('413224b8')) {
      api.createRecord('413224b8', component.options)
    } else {
      api.reload('413224b8', component.options)
    }
    module.hot.accept("./HealthInformation.vue?vue&type=template&id=413224b8&scoped=true", function () {
      api.rerender('413224b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/HealthInformation.vue"
export default component.exports